import { computed, ref, unref, watch } from 'vue';
import SalesTransactionsAPI from 'dashboard/api/salesTransactions';

const emptyCatalog = () => ({ escrituras: [], familias: [], igrejas: [] });

const entries = value =>
  (Array.isArray(value) ? value : [])
    .map(entry => ({
      value: String(entry?.id || ''),
      label: entry?.nome || entry?.name || '',
    }))
    .filter(entry => entry.value && entry.label);

const normalize = value => ({
  escrituras: entries(value?.escrituras),
  familias: entries(value?.familias),
  igrejas: entries(value?.igrejas),
});

export function useSalesPropertyCatalog({ id }) {
  const catalog = ref(emptyCatalog());
  const error = ref('');
  const loading = ref(false);
  let requestVersion = 0;

  const load = async () => {
    const transactionId = unref(id);
    requestVersion += 1;
    const version = requestVersion;

    if (!transactionId) {
      catalog.value = emptyCatalog();
      loading.value = false;
      return;
    }

    loading.value = true;
    error.value = '';
    try {
      const response =
        await SalesTransactionsAPI.propertyCatalog(transactionId);
      if (version === requestVersion)
        catalog.value = normalize(response?.data?.catalog);
    } catch (requestError) {
      if (version === requestVersion) {
        catalog.value = emptyCatalog();
        error.value =
          requestError?.response?.data?.message ||
          'property_catalog_unavailable';
      }
    } finally {
      if (version === requestVersion) loading.value = false;
    }
  };

  watch(() => unref(id), load, { immediate: true });

  return {
    catalog,
    churches: computed(() => catalog.value.igrejas),
    error,
    families: computed(() => catalog.value.familias),
    load,
    loading,
    writings: computed(() => catalog.value.escrituras),
  };
}
